import React from 'react';
import styles from './LoadingModal.module.css';

export default function LoadingModal({ text = 'Validando seus dados...' }) {
    return (
        <div className={styles.overlay}>
            <div className={styles.box}>
                <div className={styles.piggyWrap} aria-hidden="true">
                    <span className={styles.coin} style={{ animationDelay: '0s' }}>🪙</span>
                    <span className={styles.coin} style={{ animationDelay: '0.4s' }}>🪙</span>
                    <span className={styles.coin} style={{ animationDelay: '0.8s' }}>🪙</span>
                    <span className={styles.piggy}>🐷</span>
                </div>
                <p className={styles.text}>{text}</p>
                <p className={styles.sub}>Aguarde um momento</p>
            </div>
        </div>
    );
}